var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18945 10.2046C3.18945 8.26165 3.18945 7.29017 3.6096 6.54805C3.97916 5.89526 4.56887 5.36453 5.29418 5.03192C6.11876 4.65379 7.19819 4.65379 9.35705 4.65379H20.1503C22.3092 4.65379 23.3886 4.65379 24.2132 5.03192C24.9385 5.36453 25.5282 5.89526 25.8978 6.54805C26.3179 7.29017 26.3179 8.26165 26.3179 10.2046V19.9186C26.3179 21.8616 26.3179 22.8331 25.8978 23.5752C25.5282 24.228 24.9385 24.7587 24.2132 25.0913C23.3886 25.4694 22.3092 25.4694 20.1503 25.4694H9.35705C7.19819 25.4694 6.11876 25.4694 5.29418 25.0913C4.56887 24.7587 3.97916 24.228 3.6096 23.5752C3.18945 22.8331 3.18945 21.8616 3.18945 19.9186V10.2046Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3179 11.5923H3.18945M19.8934 2.34094V6.96664M9.61403 2.34094V6.96664M10.899 18.5309L14.1755 21.4219L19.2509 15.6398M9.35705 25.4694H20.1503C22.3092 25.4694 23.3886 25.4694 24.2132 25.0913C24.9385 24.7587 25.5282 24.228 25.8978 23.5752C26.3179 22.8331 26.3179 21.8616 26.3179 19.9186V10.2046C26.3179 8.26165 26.3179 7.29017 25.8978 6.54805C25.5282 5.89526 24.9385 5.36453 24.2132 5.03192C23.3886 4.65379 22.3092 4.65379 20.1503 4.65379H9.35705C7.19819 4.65379 6.11876 4.65379 5.29418 5.03192C4.56887 5.36453 3.97916 5.89526 3.6096 6.54805C3.18945 7.29017 3.18945 8.26165 3.18945 10.2046V19.9186C3.18945 21.8616 3.18945 22.8331 3.6096 23.5752C3.97916 24.228 4.56887 24.7587 5.29418 25.0913C6.11876 25.4694 7.19819 25.4694 9.35705 25.4694Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.73464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.719984bf9c7c10679a80117842e5b955.svg";
export { ForwardRef as ReactComponent };